const DEFAULT_CREATED_TIME = 'placeholder.this.week';

const EXECUTION_STATUS_ATTRIBUTE = 'executionStatus';
const CREATED_TIME_ATTRIBUTE = 'createdTime';

const DEFAULT_TOOLBAR_CONDITION = [
  {
    attribute: 'createdTime',
    operator: 'on',
    value: DEFAULT_CREATED_TIME
  }
];

const executedScriptsDefaultListInfo = {
  page: 1,
  pageSize: 50,
  sort: [
    {
      attribute: 'createdTime',
      order: 'DESC'
    }
  ],
  condition: {
    joinOperator: 'AND',
    operands: [
      {
        joinOperator: 'AND',
        operands: [
          {
            attribute: 'createdTime',
            operator: 'on',
            value: DEFAULT_CREATED_TIME
          }
        ]
      }
    ]
  }
};

const EXECUTION_STATUS_LIST = [
  {
    label: 'ALL',
    value: 'ALL'
  },
  {
    label: 'IN PROGRESS',
    value: 'IN PROGRESS'
  },
  {
    label: 'FAILURE',
    value: 'FAILURE'
  },
  {
    label: 'SUCCESS',
    value: 'SUCCESS'
  },
  {
    label: 'SKIPPED',
    value: 'SKIPPED'
  }
];

export {
  DEFAULT_CREATED_TIME,
  EXECUTION_STATUS_LIST,
  DEFAULT_TOOLBAR_CONDITION,
  EXECUTION_STATUS_ATTRIBUTE,
  CREATED_TIME_ATTRIBUTE,
  executedScriptsDefaultListInfo
};
